import React from 'react';
import {
  capitalize,
  formatDate,
} from "../../../Common/CommonFunction"; // Assuming these functions are defined elsewhere
import linkedin from "../../../../assets/images/resumeIcons/linkedin.png";
import facebook from "../../../../assets/images/resumeIcons/facebook.png";
import twitter from "../../../../assets/images/resumeIcons/twitter.png";
import stackoverflow from "../../../../assets/images/resumeIcons/stackoverflow.png";
import email from "../../../../assets/images/resumeIcons/email.png";
import call from "../../../../assets/images/resumeIcons/call.png";
import location from "../../../../assets/images/resumeIcons/location.png";
import github from "../../../../assets/images/resumeIcons/github.png";
import { educationLevelsOptions, schoolMediumsOptions, performanceScaleOptions } from "../../../../Constant";
import star_blank from "../../../../assets/images/star/star_blank.png"
import star_half from "../../../../assets/images/star/star_half.png"
import star from "../../../../assets/images/star/star.png"

const Resume = ({ jobseekerData }) => {
  const {
    jobseeker_full_name = "",
    jobseeker_date_of_birth = "",
    jobseeker_gender = "",
    jobseeker_marital_status = "",
    jobseeker_preferred_job_title = "",
    jobseeker_email1 = "",
    jobseeker_phone1 = "",
    jobseeker_location = {},
    jobseeker_photo = "",
    resume_headline = "",
    work_experience = [],
    work_sample = [],
    education = [],
    it_skills = [],
    primary_skill = [],
    country_code1 = "",
    online_detail_result = []
  } = jobseekerData;
  const renderSocialIcon = (socialProfileName) => {
    switch (socialProfileName.toUpperCase()) {
      case "LINKEDIN":
        return <img className="me-2" src={linkedin} alt="LinkedIn Icon" />;
      case "GITHUB":
        return <img className="me-2" src={github} alt="GitHub Icon" />;
      case "FACEBOOK":
        return <img className="me-2" src={facebook} alt="Facebook Icon" />;
      case "TWITTER":
        return <img className="me-2" src={twitter} alt="Twitter Icon" />;
      case "STACKOVERFLOW":
        return <img className="me-2" src={stackoverflow} alt="StackOverflow Icon" />;
      default:
        return null;
    }
  };
  return (
    <div id="resume1">
      <main className="resume1">
        <header>
          <a href="#" target="_blank"><img

            src="/job/naukrify_poweredby.png"
            // src="https://dev.naukrify.com/job/naukrify_poweredby.png"
            alt="User profile picture"
            className="img-fluid"
          /></a>
        </header>
        <div className="resume_container">
          {/* sidebar start */}
          <div className="sidebar">
            {jobseeker_photo && (
              <div className="profile_img_container mb-20">
                <img src={jobseeker_photo} alt="Profile image" />
              </div>
            )}
            <div className="sidebar-info">
              {/* <div className="contact mb-20">
                <div className="section-title">Personal Info</div>
                <div className="contact-container mt-15">
                  <table>
                    <tbody>
                      {jobseeker_date_of_birth && (
                        <tr className="email">
                          <td>
                            <img src="https://cdn-icons-png.flaticon.com/512/2886/2886665.png" alt="calendar icon" />
                          </td>
                          <td>{formatDate(jobseeker_date_of_birth)}</td>
                        </tr>
                      )}
                      {jobseeker_gender && (
                        <tr className="mobile">
                          <td>
                            <img src="https://cdn-icons-png.flaticon.com/512/9424/9424622.png" alt="gender icon" />
                          </td>
                          <td>{capitalize(jobseeker_gender)}</td>
                        </tr>
                      )}
                      {jobseeker_marital_status && (
                        <tr className="address">
                          <td>
                            <img src="https://cdn-icons-png.flaticon.com/512/1413/1413780.png" alt="couple icon" />
                          </td>
                          <td>{capitalize(jobseeker_marital_status)}</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="contact mb-20">
                <div className="section-title">Contact</div>
                <div className="contact-container mt-15">
                  <table>
                    <tbody>
                      {jobseeker_email1 && (
                        <tr className="email">
                          <td>
                            <img src="https://cdn-icons-png.flaticon.com/512/542/542689.png" alt="email icon" />
                          </td>
                          <td>
                            <a href={`mailto:${jobseeker_email1}`}>{jobseeker_email1}</a>
                          </td>
                        </tr>
                      )}
                      {jobseeker_phone1 && (
                        <tr className="mobile">
                          <td>
                            <img src="https://cdn-icons-png.flaticon.com/512/597/597177.png" alt="call icon" />
                          </td>
                          <td>
                            <a href={`tel:${country_code1}${jobseeker_phone1}`}>{country_code1}{jobseeker_phone1}</a>
                          </td>
                        </tr>
                      )}
                      {jobseeker_location.label && (
                        <tr className="address">
                          <td>
                            <img src="https://cdn-icons-png.flaticon.com/512/535/535188.png" alt="location icon" />
                          </td>
                          <td>{jobseeker_location.label}</td>
                        </tr>
                      )}
                      {online_detail_result.map((profile, index) => (
                        (profile.social_profile_name.toUpperCase() === "LINKEDIN" ||
                          profile.social_profile_name.toUpperCase() === "GITHUB") && (
                          <tr className="address" key={index}>
                            <td>{renderSocialIcon(profile.social_profile_name)}</td>
                            <td>
                              <a href={profile.url} target="_blank" rel="noopener noreferrer">
                                {profile.url}
                              </a>
                            </td>
                          </tr>
                        )
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="skills mb-20">
                <div className="section-title">Skills</div>
                <div className="list-container mt-15">
                  <ul className="list">
                    {it_skills.slice(0, 15).map((skill, index) => (
                      <li key={index} className="list-item">{skill.it_skill.label}</li>
                    ))}
                  </ul>
                </div>
              </div> */}
              {/* --- Personal Info Section --- */}
              {/* Show this block ONLY if at least one of these pieces of data exists */}
              {(jobseeker_date_of_birth || jobseeker_gender || jobseeker_marital_status) && (
                <div className="contact mb-20">
                  <div className="section-title">Personal Info</div>
                  <div className="contact-container mt-15">
                    <table>
                      <tbody>
                        {jobseeker_date_of_birth && (
                          <tr className="email">
                            <td>
                              <img src="https://cdn-icons-png.flaticon.com/512/2886/2886665.png" alt="calendar icon" />
                            </td>
                            <td>{formatDate(jobseeker_date_of_birth)}</td>
                          </tr>
                        )}
                        {jobseeker_gender && (
                          <tr className="mobile">
                            <td>
                              <img src="https://cdn-icons-png.flaticon.com/512/9424/9424622.png" alt="gender icon" />
                            </td>
                            <td>{capitalize(jobseeker_gender)}</td>
                          </tr>
                        )}
                        {jobseeker_marital_status && (
                          <tr className="address">
                            <td>
                              <img src="https://cdn-icons-png.flaticon.com/512/1413/1413780.png" alt="couple icon" />
                            </td>
                            <td>{capitalize(jobseeker_marital_status)}</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* --- Contact Section --- */}
              {/* Show this block ONLY if at least one piece of contact info exists */}
              {(jobseeker_email1 || jobseeker_phone1 || jobseeker_location.label || online_detail_result.length > 0) && (
                <div className="contact mb-20">
                  <div className="section-title">Contact</div>
                  <div className="contact-container mt-15">
                    <table>
                      <tbody>
                        {jobseeker_email1 && (
                          <tr className="email">
                            <td>
                              <img src="https://cdn-icons-png.flaticon.com/512/542/542689.png" alt="email icon" />
                            </td>
                            <td>
                              <a href={`mailto:${jobseeker_email1}`}>{jobseeker_email1}</a>
                            </td>
                          </tr>
                        )}
                        {jobseeker_phone1 && (
                          <tr className="mobile">
                            <td>
                              <img src="https://cdn-icons-png.flaticon.com/512/597/597177.png" alt="call icon" />
                            </td>
                            <td>
                              <a href={`tel:${country_code1}${jobseeker_phone1}`}>{country_code1}{jobseeker_phone1}</a>
                            </td>
                          </tr>
                        )}
                        {jobseeker_location.label && (
                          <tr className="address">
                            <td>
                              <img src="https://cdn-icons-png.flaticon.com/512/535/535188.png" alt="location icon" />
                            </td>
                            <td>{jobseeker_location.label}</td>
                          </tr>
                        )}
                        {online_detail_result.map((profile, index) => (
                          (profile.social_profile_name.toUpperCase() === "LINKEDIN" ||
                            profile.social_profile_name.toUpperCase() === "GITHUB") && (
                            <tr className="address" key={index}>
                              <td>{renderSocialIcon(profile.social_profile_name)}</td>
                              <td>
                                <a href={profile.url} target="_blank" rel="noopener noreferrer">
                                  {profile.url}
                                </a>
                              </td>
                            </tr>
                          )
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {/* --- Skills Section --- */}
              {/* Show this block ONLY if the it_skills array has items */}
              {it_skills && it_skills.length > 0 && (
                <div className="skills mb-20">
                  <div className="section-title">Skills</div>
                  <div className="list-container mt-15">
                    <ul className="list">
                      {it_skills.slice(0, 15).map((skill, index) => (
                        <li key={index} className="list-item">{skill.it_skill.label}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )}
              {/* <div className="language">
                <div className="section-title">Languages</div>
                <div className="list-container mt-15">
                  <ul className="list">
                    
                    {jobseekerData.languages && jobseekerData.languages.map((language, index) => (
                      <li key={index} className="list-item">{language}</li>
                    ))}
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
          {/* sidebar end */}
          {/* right box start */}
          <div className="main-content">
            <div className="section">
              <div className="name-container">
                <div>
                  <span className="fname">{capitalize(jobseeker_full_name)}</span>
                </div>
                <div className="resume-title">{capitalize(jobseeker_preferred_job_title)}</div>
              </div>
            </div>
            {resume_headline && (
              <div className="section">
                <div className="section-title mb-10">Objective</div>
                <div className="section-content">
                  <p>{resume_headline}</p>
                </div>
              </div>
            )}
            {education.length > 0 && (
              <div className="section">
                <div className="section-title mb-10">Education</div>
                {education.map((edu, index) => (
                  <div key={index} className="section-content">
                    {edu.education_level != "SECONDARY" &&
                      edu.education_level != "SENIOR_SECONDARY" ? (
                      <div>
                        <p> <strong>
                          {edu.jobseeker_degree &&
                            edu.jobseeker_degree.label}{" "}
                          - {edu.jobseeker_specialization} - {" "}
                          {edu.passing_year}
                        </strong>  </p>
                        <p>{edu.board}</p>
                        <p>{
                          performanceScaleOptions.find(
                            (option) =>
                              option.value == edu.performance_scale
                          )?.label
                        }{" "}
                          : {edu.performance}</p>
                      </div>
                    ) : (
                      <div>
                        <p> <strong>
                          {
                            educationLevelsOptions.find(
                              (option) =>
                                option.value == edu.education_level
                            )?.label
                          }{" "}
                          - {edu.passing_year}{" "}
                        </strong> </p>
                        <p>{edu.board} -{" "}
                          {
                            schoolMediumsOptions.find(
                              (option) => option.value == edu.school_medium
                            )?.label
                          }
                        </p>
                        <p>{
                          performanceScaleOptions.find(
                            (option) =>
                              option.value == edu.performance_scale
                          )?.label
                        }{" "}
                          : {edu.performance}</p>
                      </div>
                    )}

                  </div>
                ))}
              </div>
            )}
            {work_experience.length > 0 && (
              <div className="section">
                <div className="section-title mb-10">Work Experience</div>
                {work_experience.map((work, index) => (
                  <div key={index} className="section-content">
                    <h4>{capitalize(work.designation)} @ {work.organization.label}</h4>
                    <p>{formatDate(work.started_working_from)} - {formatDate(work.worked_till)}</p>
                    <p>{work.job_description}</p>
                  </div>
                ))}
              </div>
            )}
            {work_sample.length > 0 && (
              <div className="section">
                <div className="section-title mb-10">Work Sample</div>
                {work_sample.map((work, index) => (
                  <div key={index} className="section-content">
                    <h4>{capitalize(work.work_title)} ({formatDate(work.work_start)} - {formatDate(work.work_end)})</h4>
                    <p>
                      <a href={work.work_url}>{work.work_url}</a>
                    </p>
                    <p>{work.work_description}</p>
                  </div>
                ))}
              </div>
            )}
            {primary_skill.length > 0 && (
              <div className="section mb-4">
                <div className="section-title mb-10">Main Skills</div>
                <div className="main-skill-container">
                  {primary_skill.map((skill, index) => (
                    <div className="star-skill" key={index}>
                      <p>{skill.label}</p>
                      <div className="star-container">
                        {[...Array(5)].map((_, i) => {
                          let starImage;
                          if (i < Math.floor(skill.skill_rating / 2)) {
                            starImage = star; // Full star
                          } else if (i < Math.ceil(skill.skill_rating / 2)) {
                            starImage = star_half; // Half star
                          } else {
                            starImage = star_blank; // Empty star
                          }
                          return (
                            <img
                              key={i}
                              className="image"
                              src={starImage}
                              alt="star"
                             
                            />
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
          {/* right box end */}
        </div>
      </main>
    </div>
  );
};

export default Resume;
